import React from 'react';
import { BookOpenIcon, DropletsIcon, GiftIcon, UsersIcon } from 'lucide-react';
const items = [{
  icon: BookOpenIcon,
  label: '9 comprehensive volumes'
}, {
  icon: GiftIcon,
  label: '5 strategic bonuses'
}, {
  icon: DropletsIcon,
  label: '+300 ready-to-use resources'
}, {
  icon: UsersIcon,
  label: 'Teachers, students and professionals'
}];
export function SocialProof() {
  return <section className="border-y border-silverEdge bg-navyPanel py-5" aria-label="What the collection includes" data-id="element-216" data-mp="3ebld7yk3lwz">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-8 gap-y-3 px-4 text-sm font-semibold text-silver sm:justify-between" data-id="element-217" data-mp="8e7qjaizpje4">
        {items.map(({
        icon: Icon,
        label
      }) => <span key={label} className="inline-flex items-center gap-2" data-id="element-218" data-mp="3ushe5hf3indu">
            <Icon className="h-5 w-5 text-silverBright" aria-hidden="true" data-id="element-219" data-mp="md7esh2lbw9r" /> {label}
          </span>)}
      </div>
    </section>;
}